module.exports = __webpack_public_path__ + "img/electronic_electric_use_selected.1cfe8ccf.svg";